import React from "react";
import Topic from "./Topic";

const Topics = ({ onSubTopicChange, onTopicChange, topicId, subTopicId, topics, onSeeAllTopics }) => {

  return (
    <>
      <div className="row mt-2 mb-2">
        <div
          className="col-12"
          style={{ fontSize: "medium", paddingLeft: "25px", paddingTop: "5px" }}
        >
          Select Topic
        </div>
      </div>

      <div aria-label="Filters" style={{ marginBottom: "15px" }}>
        {topics &&
          topics.length > 0 &&
          topics.map((topic, i) => (
            <Topic
              key={`topic-${i}`}
              topicId={topic.TopicId}
              topic={topic}
              isSelected={topicId === topic.TopicId ? true : false}
              hasSelection={topicId != null ? true : false}
              onTopicChange={onTopicChange}
              onSubTopicChange={onSubTopicChange}
              subTopicId={subTopicId}
            />
          ))}
      </div>

      {topicId != null && (
        <div
          role="link"
          tabIndex="0"
          style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}
          className="nav-link"
          onClick={onSeeAllTopics}
        >
          Reset
        </div>
      )}
    </>
  );
};

export default Topics;
